export default Array.from(Array(100).keys()).map((value) => ({
  label: (value + 1).toString() + ' Serving',
  value: value + 1,
}));
